
export const blogTranslations = {
  // Navegación y UI general
  blog: 'Blog',
  blogDescription: 'Descubre artículos y consejos para mejorar tu productividad y bienestar',
  latestPosts: 'Últimas Publicaciones',
  noPostsYet: 'Aún no hay publicaciones disponibles',
  loading: 'Cargando...',
  backToBlog: 'Volver al Blog',
  postNotFound: 'Publicación no encontrada',

  // Administración
  managePosts: 'Gestionar Publicaciones',
  newPost: 'Nueva Publicación',
  editPost: 'Editar Publicación',
  publishPost: 'Publicar',
  saveDraft: 'Guardar Borrador',
  saving: 'Guardando...',
  postCreated: 'Publicación creada correctamente',
  postUpdated: 'Publicación actualizada correctamente',
  postDeleted: 'Publicación eliminada correctamente',
  confirmDeletePost: '¿Eliminar publicación?',
  confirmDeletePostDesc: 'Esta acción no se puede deshacer. La publicación será eliminada permanentemente.',

  // Estados
  published: 'Publicado',
  draft: 'Borrador',

  // Formulario
  postTitle: 'Título',
  postExcerpt: 'Resumen',
  postContent: 'Contenido',
  postCategory: 'Categoría',
  postImage: 'Imagen',
  uploadImage: 'Subir Imagen',
  uploading: 'Subiendo...',
  removeImage: 'Quitar Imagen',
  imageUploaded: 'Imagen subida correctamente',
  imageUploadError: 'Error al subir la imagen',
  hasImage: 'Con imagen',

  // Categorías
  finances: 'Finanzas',
  timeManagement: 'Gestión del Tiempo',
  productivity: 'Productividad',
  personalDevelopment: 'Desarrollo Personal',
  other: 'Otros',

  // Validaciones
  titleRequired: 'El título es obligatorio',
  titleMinLength: 'El título debe tener al menos 5 caracteres',
  titleMaxLength: 'El título no puede exceder 200 caracteres',
  excerptMaxLength: 'El resumen no puede exceder 300 caracteres',
  contentRequired: 'El contenido es obligatorio',
  contentMinLength: 'El contenido debe tener al menos 50 caracteres',
  categoryRequired: 'La categoría es obligatoria',

  // Acciones comunes
  cancel: 'Cancelar',
  delete: 'Eliminar',
  edit: 'Editar',
  success: 'Éxito',
  error: 'Error',

  // SEO
  seoTitle: 'Título SEO',
  seoDescription: 'Descripción meta',
  seoKeywords: 'Palabras clave',
  slug: 'URL amigable',
  slugGenerated: 'Slug regenerado correctamente',
  urlPreview: 'Vista previa de URL',
  copyUrl: 'URL copiada al portapapeles',
  regenerateSlug: 'Regenerar desde título',
  seoScore: 'Puntuación SEO',
  wordCount: 'Palabras',
  readingTime: 'Tiempo de lectura',
  characters: 'Caracteres',
  charactersNoSpaces: 'Sin espacios',
  paragraphs: 'Párrafos',
  autoSaved: 'Auto-guardado',
  goals: 'Objetivos',
  shortArticle: 'Artículo corto (300 palabras)',
  mediumArticle: 'Artículo medio (800 palabras)',
  longArticle: 'Artículo largo (1500 palabras)',
};

// Export as named export for compatibility
export const blog = blogTranslations;
